import { Component, OnInit,HostListener } from "@angular/core";
import { CommonHelper } from "../../../shared/helpers/CommonHelper";
import { Json2csvService } from "../../../services/json2csv.service";
import {BillingLetterService} from "../../../services/billing-letter/billing-letter.service";
import {BillingFiltersFactory} from "../../../shared/factories/billing-letters/filters.factory";
import {UrlBuilderFactory} from "../../../shared/factories/url-builder.factory";
import {LocalStorage} from "../../../shared/wrappers/LocalStorage";
import * as _ from 'lodash';


@Component({
    selector: "app-billing-letters-report",
    templateUrl: "./billing-letters-report.component.html",
    styleUrls: ["./billing-letters-report.component.css"]
})
export class BillingLettersReportComponent implements OnInit {
    filters = {
        status: { list: [], options: null, selected: [] },
        statusAllParcels: { list: [], options: null, selected: [] },
        divisions: { list: [], options: null, selected: [] },
        companies: { list: [], options: null, selected: [] },
        owners: { list: [], options: null, selected: [] },
        issued: { list: [{ name: "Não Emitido", value: false }, { name: "Emitido", value: true }], selected: null },
        name: null,
        limit: { list: [5, 10, 50, 100], selected: 10 },
        skip: 0
    };
    billingLetters: any[];
    totalItems: number = 0;
    currentPage: number = 1;
    loading;


    constructor(private billingLetterService: BillingLetterService,
                private billingFiltersFactory: BillingFiltersFactory,
                private queryStringFactory: UrlBuilderFactory,
                private localStorage: LocalStorage,
                private json2csvService: Json2csvService,
                private commonHelper:CommonHelper) { }

    async ngOnInit() {
        this.loading = true;
        this.filters = await this.billingFiltersFactory.build(this.filters, 'billing-report-filters');
        await this.search(1);
        this.loading = false;
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {

        if (event.keyCode === 13) {
            this.search(1);
        }

    }

    async search(page?: number) {
        this.loading = true;
        this.currentPage = 1;
        const response = await this.billingLetterService.getAllOld(this.queryStringFactory.build(this.loadFilters(page)));
        this.billingLetters = _.get(response, 'billingLetters', []);
        this.totalItems = _.get(response, 'totalItems', 0);
        this.loading = false;
    }

    find(filter, id) {
        const filterFound = _.find(_.get(this.filters, `${filter}.list`, []), (division) => division.id == id);

        return filterFound ? filterFound : { id: null, itemName: '--' };
    }

    loadFilters(page?) {
        this.currentPage = page ? page : (this.currentPage ? this.currentPage : 1);

        let filters = {};

        _.forOwn(this.filters, (value, key) => {
            const selected = _.get(value, 'selected', value);
            if (selected == 'undefined' || selected == null) return;

            filters[key] = selected;
            filters[key] = _.isArray(filters[key]) ? filters[key].map(item => _.get(item, 'id')) : filters[key];
        });

        return {
            ...filters,
            limit: this.filters.limit.selected,
            skip: (this.currentPage - 1) * this.filters.limit.selected
        };
    }

    saveFilters() {
        this.localStorage.save(this.loadFilters(), 'billing-report-filters');
    }


}



// WEBPACK FOOTER //
// ./src/app/views/reports/billing-letters-report/billing-letters-report.component.ts